export type ReportSectionKey =
  | "socialMediaPerformance"
  | "aiChatbotManagement"
  | "aiPodcastProgress"
  | "blogManagement"
  | "seoManagement"
  | "adsManagement"
  | "generatedLeads"
  | "promotionalMaterials"
  | "journey";

export interface ReportSectionConfigItem {
  key: ReportSectionKey;
  label: string;
  helper: string;
  requiresFiles: boolean;
  requiresInsight: boolean;
  hasRecommendation: boolean;
  dbKey: string;
}

export const reportSectionConfig: ReportSectionConfigItem[] = [
  {
    key: "journey",
    label: "The Three-Month Journey",
    helper: "3-Month progress summary: baseline setup, growth, and active lead capture.",
    requiresFiles: true,
    requiresInsight: false,
    hasRecommendation: false,
    dbKey: "journey",
  },
  {
    key: "socialMediaPerformance",
    label: "Social Media Performance",
    helper: "Content output, audience growth, and engagement.",
    requiresFiles: true,
    requiresInsight: false,
    hasRecommendation: false,
    dbKey: "social_media_performance",
  },
  {
    key: "aiChatbotManagement",
    label: "AI Chatbot Management",
    helper: "Inquiry support, lead qualification, and automated replies.",
    requiresFiles: true,
    requiresInsight: false,
    hasRecommendation: false,
    dbKey: "ai_chatbot_management",
  },
  {
    key: "aiPodcastProgress",
    label: "AI Podcast Progress",
    helper: "Educational podcast library, episode batches, creation, and approval progress.",
    requiresFiles: true,
    requiresInsight: false,
    hasRecommendation: false,
    dbKey: "ai_podcast_progress",
  },
  {
    key: "blogManagement",
    label: "Blog Management",
    helper: "Website authority updates, SEO articles, and resources.",
    requiresFiles: true,
    requiresInsight: false,
    hasRecommendation: false,
    dbKey: "blog_management",
  },
  {
    key: "seoManagement",
    label: "SEO Management",
    helper: "Organic indexing, ranking tracking, and technical optimization.",
    requiresFiles: true,
    requiresInsight: false,
    hasRecommendation: false,
    dbKey: "seo_management",
  },
  {
    key: "adsManagement",
    label: "Ads Management",
    helper: "Paid search engine visibility and social campaign execution.",
    requiresFiles: true,
    requiresInsight: false,
    hasRecommendation: false,
    dbKey: "ads_management",
  },
  {
    key: "generatedLeads",
    label: "Generated Leads",
    helper: "Current verified inquiry activity by recorded source and monthly breakdown.",
    requiresFiles: true,
    requiresInsight: false,
    hasRecommendation: false,
    dbKey: "generated_leads",
  },
  {
    key: "promotionalMaterials",
    label: "Promotional Materials",
    helper: "Print and digital collateral including brochures, flyers, and stationery.",
    requiresFiles: true,
    requiresInsight: false,
    hasRecommendation: false,
    dbKey: "promotional_materials",
  },
];

export interface ReportSectionFile {
  id?: number | string;
  file?: File;
  name: string;
  url?: string;
  previewUrl?: string;
  mimeType?: string;
  size?: number;
  source: "local" | "server";

  extractedText?: string;
  extractionStatus?:
    | "pending"
    | "extracting"
    | "completed"
    | "failed";

  extractionError?: string;
  wordCount?: number;
  characterCount?: number;
}

export interface ExtractedFileContent {
  clientKey: string;
  filename: string;
  mimeType: string;
  text: string;
  wordCount: number;
  characterCount: number;
}
